/**
 * Planilha para o Excel ou para o R. O padrao e o Excel em portugues: ponto e
 * virgula entre colunas e virgula decimal — senao o Excel brasileiro abre tudo
 * numa coluna so, ou le 152.5 como 1525. BOM UTF-8 para os acentos, e CRLF
 * entre linhas, como o Excel espera.
 */
export interface FormatoCsv {
  separador: ';' | ',';
  decimal: ',' | '.';
}

export const EXCEL_PT_BR: FormatoCsv = { separador: ';', decimal: ',' };
export const INTERNACIONAL: FormatoCsv = { separador: ',', decimal: '.' };

export interface ColunaCsv {
  chave: string;
  titulo: string;
}

export function paraCsv(
  colunas: readonly ColunaCsv[],
  linhas: readonly Record<string, unknown>[],
  formato: FormatoCsv = EXCEL_PT_BR,
): string {
  const celula = (v: unknown): string => {
    if (v == null) return '';
    let t: string;
    if (typeof v === 'number') t = Number.isFinite(v) ? String(v).replace('.', formato.decimal) : '';
    else if (typeof v === 'boolean') t = v ? 'sim' : 'nao';
    else t = String(v);
    return /["\r\n]/.test(t) || t.includes(formato.separador) ? `"${t.replace(/"/g, '""')}"` : t;
  };
  const cabecalho = colunas.map((c) => celula(c.titulo)).join(formato.separador);
  const corpo = linhas.map((l) => colunas.map((c) => celula(l[c.chave])).join(formato.separador));
  return `﻿${[cabecalho, ...corpo].join('\r\n')}\r\n`;
}
